module.exports = __webpack_public_path__ + "img/asus.236d32e1.svg";